<template>
  <div class="container" id="container">
    <div class="info">
      <div class="title">{{ VendorInfo.vendorName }}</div>
      <div class="zxgg"></div>
      <div class="containerBox" @scroll="handleScroll">
        <div v-for="(item, index) in msgList" :key="index">
          <!-- 用户 -->
          <div class="info_msg" v-if="item.isUser == 1">
            <div class="info_msg_img">
              <img v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" />
              <img v-else src="@/assets/img/heard.png" />
            </div>
            <div class="info_msg_input">
              <div class="msg" style="white-space:pre-wrap;" v-if="item.contentType == 1" v-html="item.content"></div>
              <div v-if="item.contentType == 2" @click="toPreImg(baseUrl + item.content)"><img
                  :src="baseUrl + item.content" /></div>
              <div class="time">{{ item.createTime | getLocalTime }}
                <span> {{ item.isRead == 1 ? $t('c2c').Read : $t('c2c').Unread }}</span>
              </div>
            </div>
          </div>
          <!-- 供应商 -->
          <div class="info_answer" v-if="item.isUser == 0">
            <div class="info_answer_img">{{ VendorInfo.vendorName.substring(0, 1) }}</div>
            <div class="info_answer_input">
              <div class="msg" style="white-space:pre-wrap;" v-if="item.contentType == 1" v-html="item.content"></div>
              <div v-if="item.contentType == 2" @click="toPreImg(baseUrl + item.content)"><img
                  :src="baseUrl + item.content" /></div>
              <div class="time">{{ item.createTime | getLocalTime }}
                <span>{{ item.isRead == 1 ? $t('c2c').Read : $t('c2c').Unread }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="input_xx"></div>
        <div class="input_foot">
          <div class="input_msg">
            <van-uploader class="upImg" :preview-image="false" :after-read="justAfterRead">
              <svg-icon class-name="svgs" icon-class="add" />
            </van-uploader>
            <van-field v-model="inputMsg" :placeholder="$t('c2c').inputTips"></van-field>
          </div>
          <div class="input_btn" @click="toSubMsg">{{ $t('c2c').send }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chatApi from '@/api/chat'
import userApi from '@/api/user'
import systemApi from '@/api/system'
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      baseUrl: window.baseURL,
      inputMsg: "",
      inputType: "1",
      tradeId: "",
      msgList: [],
      num: 0,
      timer: "",
      VendorInfo: { vendorName: '' },
      userInfo: {},
    }
  },
  mounted() {
    this.tradeId = this.$route.query.id
    window.addEventListener('scroll', this.handleScroll)
    this.getVendorInfo()
    this.getMemberInfo()
    this.getList()
    this.timer = setInterval(this.getList, 3000)
    let that = this
    setTimeout(function () {
      that.toBootom()
    }, 500)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.timer)
  },
  methods: {
    handleScroll() {
    },
    toBootom() {
      const container = document.getElementById('container');
      container.scrollIntoView(false);
    },
    // 获取供应商信息
    async getVendorInfo() {
      const res = await chatApi.getVendorInfo({ tradeId: this.tradeId })
      this.VendorInfo = res.data
    },
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    // 聊天列表
    async getList() {
      const res = await chatApi.getTalkItemList({ tradeId: this.tradeId })
      this.msgList = res.data
      if (this.msgList.length > this.num) {
        this.toBootom()
        this.num = this.msgList.length
      }
    },
    // 预览图片
    toPreImg(val) {
      ImagePreview([val]);
    },
    // 上传图片
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.inputMsg = res.fileName
      this.inputType = "2"
      this.toSubMsg()
    },
    // 提交信息
    async toSubMsg() {
      if (this.inputMsg == '')
        return
      var msg = {
        tradeId: this.tradeId,
        content: this.inputMsg,
        contentType: this.inputType
      }
      this.inputMsg = ''
      this.inputType = "1"
      const res = await chatApi.creatTalkItem(msg)
      this.getList()
    },
  }
}
</script>

<style lang="less" scoped>
.c-c-sb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);
}

.title {
  font-size: 20px;
  color: var(--text_color);
  margin: 0 auto;
  max-width: 1280px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--info_color);
}

.info {
  margin: 0 auto;
  max-width: 780px;
}

.zxgg {
  height: 44px;
}

.input_xx {
  height: 150px;
  background: var(--background_color);
}

.info_msg {
  display: flex;
  flex-direction: row-reverse;
  margin: 15px 0;

  .info_msg_img {
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .info_msg_input {
    font-size: 14px;
    color: var(--text_color);
    line-height: 1.5;
    margin-right: 10px;
    padding: 8px;
    background: var(--background_color);
    border-radius: 15px;
    border: 1px solid var(--info_color);
    max-width: 68.5%;

    .time {
      font-size: 12px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
      }
    }
  }
}

.info_answer {
  display: flex;
  margin: 15px 0;

  .info_answer_img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 10px;
    background: var(--text_color);
    font-size: 18px;
    color: var(--background_color);
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info_answer_input {
    font-size: 14px;
    color: var(--text_color);
    line-height: 1.5;
    margin-left: 10px;
    padding: 8px;
    background: var(--background_color);
    border-radius: 15px;
    border: 1px solid var(--info_color);
    max-width: 68.5%;

    .time {
      font-size: 12px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
      }
    }
  }
}

.input_foot {
  margin: 0 auto;
  max-width: 780px;
  border-top: 1px solid var(--info_color);
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--background_color);
  padding: 10px;
  z-index: 100;

  .input_msg {
    width: 80%;
    border-radius: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;

    .upImg {
      margin-right: 5px;

      .svgs {
        width: 25px;
        height: 25px;
        color: var(--text_color);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .input_btn {
    text-align: center;
    background: var(--text_color);
    height: 30px;
    line-height: 30px;
    color: var(--background_color);
    width: 20%;
    margin-left: 10px;
    border-radius: 10px;
    font-size: 13px;

    &:hover {
      opacity: 0.8;
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 40px;
  padding: 0 10px;
  border-radius: 10px;
  font-size: 14px;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>
